import React from "react";
import { Outlet } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { CookieConsent } from "@/components/CookieConsent";
import { CheckPromoBar } from "@/components/CheckPromoBar";
import { ChatWidget } from "@/components/ChatWidget";

export const Layout = () => (
  <div className="min-h-screen bg-white text-ink relative">
    <Header />
    <main className="relative z-10 pt-20" id="main-content">
      <Outlet />
    </main>
    <Footer />
    <CookieConsent />
    <CheckPromoBar />
    <ChatWidget />
  </div>
);
